// src/modules/portal/components/VIPGreetingBanner.tsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Sparkles, Trophy, ArrowRight } from 'lucide-react';
import { LegendService } from '../../../services/legendService';
import { FishingLegend } from '../../../data/legends';
import ManelMascot from '../../../components/ManelMascot';

export const VIPGreetingBanner: React.FC = () => {
  const [legend, setLegend] = useState<FishingLegend | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Simulação: Detecta lenda se houver um email específico no localStorage ou mock
    const checkLegend = async () => {
      // Para fins de demonstração, vamos simular que o Nelson Nakamura entrou
      // Em produção, isso viria do AuthContext (user.email, user.displayName)
      const mockUser = {
        email: 'nelson@nossapesca.com',
        fullName: 'Nelson Nakamura'
      };

      const detected = await LegendService.detectLegend(mockUser);
      if (detected) {
        setLegend(detected);
        // Pequeno delay para impacto
        setTimeout(() => setIsVisible(true), 1500);
      }
    };

    checkLegend();
  }, []);

  if (!legend || !isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[500] p-4"
      >
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 rounded-2xl shadow-2xl p-6 border-b-4 border-amber-600 flex items-center gap-6 relative overflow-hidden">
          {/* Background Decor */}
          <div className="absolute -right-10 -bottom-10 opacity-10 rotate-12">
            <Trophy size={200} />
          </div>

          <div className="shrink-0 bg-white/20 p-2 rounded-full backdrop-blur-sm animate-pulse">
            <ManelMascot pose={6} width={80} />
          </div>

          <div className="flex-grow">
            <div className="flex items-center gap-2 mb-1">
              <Sparkles className="text-white fill-white" size={16} />
              <span className="text-[10px] font-black uppercase tracking-[0.3em] text-amber-900/60">
                Presença Ilustre Detectada
              </span>
            </div>
            <h3 className="text-2xl font-black text-amber-950 leading-tight">
              Seja muito bem-vindo, mestre {legend.fullName}!
            </h3>
            <p className="text-amber-900/80 font-medium text-sm mt-1">
              O portal Nossa Pesca se honra com a sua presença. O Manél e toda a equipe estão às suas ordens.
            </p>
          </div>

          <div className="flex flex-col gap-2 shrink-0">
            <button 
              onClick={() => setIsVisible(false)}
              className="absolute top-4 right-4 text-amber-950/40 hover:text-amber-950 transition-colors"
              aria-label="Fechar saudação VIP"
              title="Fechar"
            >
              <X size={20} />
            </button>
            <button className="bg-amber-950 text-amber-400 px-6 py-2 rounded-full font-bold text-sm hover:scale-105 transition-transform flex items-center gap-2">
              Área VIP <ArrowRight size={16} />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
